
<!--<bm-dunning-assign-payments></bm-dunning-assign-payments>-->

<div class="h-full">
    <div class="grid m-0">
        <div class="surface-0 border-round-md p-3 col-7"  >
            <div class="flex flex-column gap-3">
                <div class="grid">
                    <div class="col-12">
                        <div class="flex align-items-center justify-content-between border-bottom-1 border-300 pb-2">
                                <h3 class="m-0 text-2xl font-semibold">Zahlungsplan generieren</h3>
                            <div class="flex flex-column gap-2">
                                <div class="flex gap-2 justify-content-end">
                                    <p-button label="Validation"></p-button>
                                    <p-button label="Process" severity="secondary"></p-button>
                                </div>
<!--                                <div class="flex justify-content-end align-items-center gap-2">-->
<!--                                    <label for="ingredient1">Kunden schriftlich in Kenntnis setzten</label>-->
<!--                                    <p-toggleswitch id="ingredient1"/>-->
<!--                                </div>-->
                            </div>
                        </div>
                    </div>

                    <div class="col-12">
                        <div class="flex justify-content-between">
                            <div>
                                <h4>Abbrechnungskontobelastung</h4>
                            </div>
                            <div>
                                <p-datePicker [(ngModel)]="selectedDate"/>
                            </div>
                        </div>
                    </div>

                    <!--     TOTAL VIEW       -->
                    <div class="grid col-12">
                            <bm-dunning-assign-payments></bm-dunning-assign-payments>
                    </div>
                </div>

            </div>
        </div>
        <div  class="col-5 px-2 py-0" >
            <div class="sticky" style="top: 6rem">
                <p-card>

                    <p-tabs [(value)]="activeTab">
                        <p-tablist>
                            <p-tab value="0">Invoice Overview</p-tab>
                            @if (selectedContract) {
                                <p-tab value="1">
                                    <div class="flex align-items-center gap-2">
                                        <span>Contract</span>

                                        <i
                                                class="pi pi-times text-sm cursor-pointer opacity-70 hover:opacity-100"
                                                (click)="closeContractToolbar(); $event.stopPropagation()"
                                                aria-label="Close contract tab"
                                                role="button"
                                                tabindex="0">
                                        </i>
                                    </div>
                                </p-tab>
                            }
                        </p-tablist>
                        <p-tabpanels>
                            <p-tabpanel value="0">
                                <bm-dunning-assign-payments-calculation-component></bm-dunning-assign-payments-calculation-component>
                            </p-tabpanel>
                            <!-- RIGHT TOOLBAR -->
                            @if (selectedContract) {
                                <p-tabpanel value="1">

                                    @if (selectedContract) {
                                        <mvs-object
                                                style="height: calc(100vh - 18vh); overflow: auto; display: block;"
                                                objectType="cm.Contract"
                                                [objectId]="51355"
                                                uiMode="mini-side"
                                        ></mvs-object>
                                    }


                                    <!--                                    <bm-contract-toolbar-->
                                    <!--                                            style="height: calc(100vh - 18vh); overflow: auto; display: block;"-->
                                    <!--                                            [contract]="selectedContract"-->
                                    <!--                                            (close)="closeContractToolbar()">-->
                                    <!--                                    </bm-contract-toolbar>-->
                                </p-tabpanel>
                            }
                        </p-tabpanels>
                    </p-tabs>

                </p-card>
            </div>

        </div>
    </div>
</div>


